module.exports = __webpack_public_path__ + "img/es-top-bg.a0b7a3c9.png";